import PropTypes from 'prop-types'
import { useState } from 'react'
require('./index.scss')

import Dialog from '@/components/Dialog'
import { translate } from '@/utils/translations'

const AssetFormatModal = ({ format }) => {
  const [show, setShow] = useState(false)
  const onHandleShow = e => {
    setShow(true)
    e.preventDefault()
  }
  const classNames = [
    'vst-btn--transparent',
    'asset_format_modal_trigger'
  ].join(' ')

  return (
    <>
      <button
        className={classNames}
        data-testid='asset-format-link'
        id='asset-format'
        onClick={e => onHandleShow(e)}
        type='button'
      >
        {translate('common.whats_this')}
      </button>
      <Dialog
        heading={translate(`product_display.${format}_header`)}
        id='asset-format-modal'
        isShowing={show}
        onChangeShow={setShow}
      >
        <div>
          <p>
            {translate(`product_display.${format}_description_paragraph_one`)}
          </p>
          <p>
            {translate(`product_display.${format}_description_paragraph_two`)}
          </p>
        </div>
      </Dialog>
    </>
  )
}

export default AssetFormatModal

AssetFormatModal.propTypes = {
  format: PropTypes.string.isRequired
}
